export default "__VITE_ASSET__BmQZPl9n__"